export default __webpack_public_path__ + "static/media/insta.ffcb8eb5.svg";